




























import { Individu } from "@/models/Individu";
import { Pointage } from "@/models/Pointage";
import store from "@/store";
import IconePresence from "@/components/icone-presence.vue";
import IconeAbsence from "@/components/icone-absence.vue";
import { TarifEventSchedulerActiviteDocument, } from "@/models/TarifEventSchedulerActiviteDocument";
import { Vue } from "vue-property-decorator";
export default Vue.extend({
props:["now","currentActiviteID","pointages", "temps", "enfant","pointagePrevi","listPalette","pointageActif"],
components: { IconePresence , IconeAbsence},

computed:{
etime:function(){
  return Date.now()-this.enfant.getEtime();
},
p1:function(){return "pointageAN" +
      this.now +
      this.currentActiviteID +
      this.temps.getFriseElement_id() +
      this.enfant.getId();
},
p2:function()
{ return "pointageAN" +
      this.now +
      this.currentActiviteID +
      this.temps.getTempsTarif_id() +
      this.enfant.getId();
},
isPointageActif( ): boolean {
  if(this.pointageActif.length == 0)
    return false;
    for(const p of  this.pointages as Array<any>){
        if (p._id ===this.p1 || p._id===this.p2){
             return true;
      }
      
    }          
    return false;      
},
foundPointage() {

return this.pointages.find((pointage:any) =>
  pointage._id === this.p1 || pointage._id === this.p2
);
},
},
methods:{


getPaletteFromIndTemps():any {
const foundPalette:any = this.listPalette.find((palette:any) =>
palette.getId() === (this.foundPointage ? this.foundPointage.getPaletteId() : -32)
);

return foundPalette !== undefined ? foundPalette : this.listPalette.find((palette:any) => palette.getId() === -32);
},

selectImgPreviOuRien(
temps: TarifEventSchedulerActiviteDocument,
enfant: Individu
) {
if (
  this.pointagePrevi.some(
    (pointPrevi: any) =>
      ((pointPrevi.elementfrise_id === temps.getFriseElement_id() ||
      pointPrevi.tariftempssupplactivite_id == temps.getTempsTarif_id()) &&
      pointPrevi.individu_id === enfant.getId())
  ) 
) {
  return require(`@/assets/pointage/RESERVATION_GRILLE_POINTAGE.svg`);
} else {
  return require(`@/assets/pointage/PAS_RESERVE_GRILLE_POINTAGE.svg`);
}
},
log(msg:any){
  console.log(msg)
},

isPointageInoe(): boolean {
console.log(1)
 let pointage: Pointage = this.getPointage() as Pointage;
 return typeof pointage !== "undefined" ? pointage.isIsInoe() : false;
},

getPointage() {
return this.pointages.find(
  (pointage: any) =>
    pointage.get_id() ===
     this.p1||
    pointage.get_id() ===
      this.p2
);
},

}

})
